import React from 'react'
import { graphql } from 'gatsby'
import Layout from '../components/Layout'
import Container from '../components/Container'
import PageBody from '../components/PageBody'
import TagList from '../components/TagList'
import PostLinks from '../components/PostLinks'
import PostDetails from '../components/PostDetails'
import SEO from '../components/SEO'
import PostTwoColumn from '../components/PostTwoColumn'

const PostTemplate = ({ data, pageContext }) => {
  const {
    title,
    metaDescription,
    heroImage,
    body,
    publishDate,
    tags,
    translation,
  } = data.contentfulPost

  const previous = pageContext.prev
  const next = pageContext.next
  const { basePath } = pageContext

  let ogImage
  try {
    ogImage = heroImage.ogimg.src
  } catch (error) {
    ogImage = null
  }

  let pageBody
  if (translation) {
    pageBody = (
      <PostTwoColumn>
        <PageBody body={body} />
        <PageBody body={translation} />
      </PostTwoColumn>
    )
  } else {
    pageBody = <PageBody body={body} />
  }

  return (
    <Layout>
      <SEO
        title={title}
        description={
          metaDescription
            ? metaDescription.internal.content
            : body.childMarkdownRemark.excerpt
        }
        image={ogImage}
      />
      {/* <Hero title={title}  height={'50vh'} /> */}
      <Container>
        <PostDetails
          date={publishDate}
          timeToRead={body.childMarkdownRemark.timeToRead}
          title={title}
        />

        {pageBody}
        {tags && <TagList tags={tags} basePath={basePath} />}

        <PostLinks previous={previous} next={next} basePath={basePath} />
      </Container>
    </Layout>
  )
}

export const query = graphql`
  query($slug: String!) {
    contentfulPost(slug: { eq: $slug }) {
      title
      slug
      metaDescription {
        internal {
          content
        }
      }
      publishDate(formatString: "MMMM DD, YYYY")
      publishDateISO: publishDate(formatString: "YYYY-MM-DD")
      tags {
        title
        id
        slug
      }
      heroImage {
        title
        fluid(maxWidth: 1800) {
          ...GatsbyContentfulFluid_withWebp_noBase64
        }
        ogimg: resize(width: 1800) {
          src
        }
      }
      body {
        childMarkdownRemark {
          timeToRead
          html
          excerpt(truncate: true)
        }
      }
      translation {
        childMarkdownRemark {
          html
        }
      }
    }
  }
`

export default PostTemplate
